module.exports = __webpack_public_path__ + "static/quality-guarantee-c01a8fe4dcc51c0148c1023af470bf64.png";